/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Order/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Order({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Apps/Orders/Content/Order"
  
}) {
let orderTitleValueData = fromData.useDataValue({ viewPath,
context: 'order',
path: 'title',
})
let constantData = ':'
let orderStatusValueData = fromData.useDataFormat({ viewPath,
context: 'order',
path: 'status',
format: fromHelpers.toHumanStatus,
})
let aggregateData = fromAggregate.join(orderTitleValueData, constantData, orderStatusValueData)
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style="filled"
 size="tiny"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="order.title"
 data="':'"
 data="order.status"
 format="helpers.js toHumanStatus"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
)}
</TysiaTag>
{children}
</React.Fragment>)
}